export const validateConfirmationForm = (formData) => {
  const errors = {};

  const requiredFields = [
    { key: 'entry_date_time', label: 'Surgery Date & Time' },
    { key: 'bp', label: 'BP (Blood Pressure)' },
    { key: 'heart_rate', label: 'Heart Rate' },
    { key: 'anaesthesia_type', label: 'Anesthesia Type' },
    { key: 'doctor_name', label: 'Final Physician Name' },
    { key: 'legal_representative_contact', label: 'Legal Representative Contact' },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!formData[key] || String(formData[key]).trim() === '') {
      errors[key] = `${label} is required`;
    }
  });

  if (formData.anaesthesiologist_clearance) {
    if (!formData.anaesthesiologist_name || String(formData.anaesthesiologist_name).trim() === '') {
      errors.anaesthesiologist_name = 'Anaesthesiologist Name is required';
    }
  }

  // Date validations
  if (formData.covid_screening && formData.covid_screening_date) {
    const selected = new Date(formData.covid_screening_date);
    const now = new Date();
    if (selected > now) {
      errors.covid_screening_date = 'COVID-19 screening date/time cannot be in the future.';
    }
  }

  return errors;
};
